import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center h-20 border-b border-b-gray-800" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "bg-white" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[9] || (_cache[9] = _createElementVNode("a", {
              href: "#",
              class: "flex items-center ml-4"
            }, [
              _createElementVNode("img", {
                src: "/symbol_72px.png",
                alt: "logo",
                style: {"width":"48px","height":"48px"}
              }),
              _createElementVNode("span", { class: "ml-4 font-bold text-2xl" }, "HEAT AID")
            ], -1)),
            _createVNode(_component_el_button, {
              link: "",
              onClick: _ctx.logout,
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 30 }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[8] || (_cache[8] = [
                      _createElementVNode("g", null, [
                        _createElementVNode("image", {
                          x: "0",
                          y: "0",
                          "xlink:href": "data:image/png;base64,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",
                          preserveAspectRatio: "none",
                          width: "100%",
                          height: "100%"
                        })
                      ], -1)
                    ])))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { style: {"height":"calc(100vh - 80px)"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            style: _normalizeStyle([{ width: _ctx.isCollapse ? '80px' : '240px' }, {"overflow-x":"hidden"}])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": _ctx.defaultActive,
                "default-openeds": ['System'],
                class: "el-menu-vertical-demo shadow-md",
                collapse: _ctx.isCollapse,
                "active-text-color": "#409EFF",
                style: {"height":"calc(100vh - 80px)"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: _ctx.ROUTES.DASHBOARD,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.DASHBOARD}`)))
                  }, {
                    title: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("ダッシュボード")
                    ])),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Document)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["index"]),
                  _createVNode(_component_el_sub_menu, { index: "System" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Setting)
                        ]),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "システム管理", -1))
                    ]),
                    default: _withCtx(() => [
                      ([_ctx.ROLES.SYSTEM].includes(_ctx.loginUserRole))
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 0,
                            index: _ctx.ROUTES.MNT_COMPANY,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.MNT_COMPANY}`)))
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" 契約会社管理 ")
                            ])),
                            _: 1
                          }, 8, ["index"]))
                        : _createCommentVNode("", true),
                      ([_ctx.ROLES.SYSTEM, _ctx.ROLES.ADMIN].includes(_ctx.loginUserRole))
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 1,
                            index: _ctx.ROUTES.MNT_USER,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.MNT_USER}`)))
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode(" 安全責任者管理 ")
                            ])),
                            _: 1
                          }, 8, ["index"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_menu_item, {
                        index: _ctx.ROUTES.MNT_SITE,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.MNT_SITE}`)))
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode(" 現場管理 ")
                        ])),
                        _: 1
                      }, 8, ["index"]),
                      ([_ctx.ROLES.SYSTEM, _ctx.ROLES.ADMIN].includes(_ctx.loginUserRole))
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 2,
                            index: _ctx.ROUTES.MNT_SENSOR,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.MNT_SENSOR}`)))
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" センサー管理 ")
                            ])),
                            _: 1
                          }, 8, ["index"]))
                        : _createCommentVNode("", true),
                      ([_ctx.ROLES.SYSTEM].includes(_ctx.loginUserRole))
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 3,
                            index: _ctx.ROUTES.MNT_OPERATOR,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.MNT_OPERATOR}`)))
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" 作業員（端末）参照 ")
                            ])),
                            _: 1
                          }, 8, ["index"]))
                        : _createCommentVNode("", true),
                      ([_ctx.ROLES.SYSTEM].includes(_ctx.loginUserRole))
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 4,
                            index: _ctx.ROUTES.ENV_SETTINGS,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.ENV_SETTINGS}`)))
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" 環境設定 ")
                            ])),
                            _: 1
                          }, 8, ["index"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: _ctx.ROUTES.PERSONAL_SETTINGS,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.push(`/${_ctx.ROUTES.PERSONAL_SETTINGS}`)))
                  }, {
                    title: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("個人設定")
                    ])),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Avatar)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["index"])
                ]),
                _: 1
              }, 8, ["default-active", "collapse"])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_el_main, {
            style: _normalizeStyle([{"padding":"0px"}, { width: _ctx.isCollapse ? 'calc(100% - 80px)' : 'calc(100% - 240px)' }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}